// @ts-nocheck
import MarkdownIt, { Token } from 'markdown-it';

/**
 * Original: https://github.com/revin/markdown-it-task-lists/blob/master/index.js (Sep 22, 2023)
 * (ISC License)
 *
 */
let disableCheckboxes = true;
let useLabelWrapper = false;
let useLabelAfter = false;

const render: MarkdownIt.PluginWithOptions = (md, options) => {
    if (options) {
        disableCheckboxes = !options.enabled;
        useLabelWrapper = !!options.label;
        useLabelAfter = !!options.labelAfter;
    }

    md.core.ruler.after('inline', 'github-task-lists', function (state) {
        const tokens = state.tokens;
        for (let i = 2; i < tokens.length; i++) {
            if (isTodoItem(tokens, i)) {
                todoify(tokens[i], state.Token);
                attrSet(tokens[i - 2], 'class', 'task-list-item' + (!disableCheckboxes ? ' enabled' : ''));
                attrSet(tokens[parentToken(tokens, i - 2)], 'class', 'contains-task-list');
            }
        }
    });
};
export default render;


function attrSet(token, name, value) {
    const index = token.attrIndex(name);
    const attr = [name, value];

    if (index < 0) {
        token.attrPush(attr);
    }
    else {
        token.attrs[index] = attr;
    }
}

function parentToken(tokens, index: number) {
    const targetLevel = tokens[index].level - 1;
    for (let i = index - 1; i >= 0; i--) {
        if (tokens[i].level === targetLevel) {
            return i;
        }
    }
    return -1;
}

function isTodoItem(tokens, index: number) {
    return isInline(tokens[index]) &&
        isParagraph(tokens[index - 1]) &&
        isListItem(tokens[index - 2]) &&
        startsWithTodoMarkdown(tokens[index]);
}

function todoify(token, TokenConstructor: Token) {
    token.children.unshift(makeCheckbox(token, TokenConstructor));
    token.children[1].content = token.children[1].content.slice(3);
    token.content = token.content.slice(3);

    if (useLabelWrapper) {
        if (useLabelAfter) {
            token.children.pop();

            // Use large random number as id property of the checkbox.
            const id = 'task-item-' + Math.ceil(Math.random() * (10000 * 1000) - 1000);
            token.children[0].content = token.children[0].content.slice(0, -1) + ' id="' + id + '">';
            token.children.push(afterLabel(token.content, id, TokenConstructor));
        }
        else {
            token.children.unshift(beginLabel(TokenConstructor));
            token.children.push(endLabel(TokenConstructor));
        }
    }
}

function makeCheckbox(token, TokenConstructor: Token) {
    const checkbox = new TokenConstructor('html_inline', '', 0);
    const disabledAttr = disableCheckboxes ? ' disabled="" ' : '';

    if (token.content.indexOf('[ ] ') === 0) {
        checkbox.content = '<input class="task-list-item-checkbox"' + disabledAttr + 'type="checkbox">';
    }
    else if (token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0) {
        checkbox.content = '<input class="task-list-item-checkbox" checked=""' + disabledAttr + 'type="checkbox">';
    }
    return checkbox;
}

// these next two functions are kind of hacky; probably should really be a
// true block-level token with .tag=='label'
function beginLabel(TokenConstructor: Token) {
    const token = new TokenConstructor('html_inline', '', 0);
    token.content = '<label>';
    return token;
}

function endLabel(TokenConstructor: Token) {
    const token = new TokenConstructor('html_inline', '', 0);
    token.content = '</label>';
    return token;
}

function afterLabel(content: string, id: string, TokenConstructor: Token) {
    const token = new TokenConstructor('html_inline', '', 0);
    token.content = '<label class="task-list-item-label" for="' + id + '">' + content + '</label>';
    token.attrs = [{ for: id }] as any;
    return token;
}

function isInline(token) { return token.type === 'inline'; }
function isParagraph(token) { return token.type === 'paragraph_open'; }
function isListItem(token) { return token.type === 'list_item_open'; }

function startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
